import { useState, type FormEvent } from 'react';
import { useSession } from '../lib/session';
import '../styles/login.css';

const DEMO = [
  { role: 'Propietario', email: 'admin@nexo.ae', note: 'lo ve todo' },
  { role: 'Comercial', email: 'comercial@nexo.ae', note: 'no factura ni corrige' },
  { role: 'Superusuario financiero', email: 'finanzas@nexo.ae', note: 'puede rectificar' },
  { role: 'Auditor', email: 'auditor@nexo.ae', note: 'solo lectura' },
];

// Una tira estática que insinúa la firma antes de entrar.
const DEMO_STRIP = ['active', 'active', 'active', 'active', 'gated', 'active', 'active', 'gated', 'dormant', 'active', 'active', 'active', 'broken', 'active', 'gated', 'dormant'];
const STRIP_BG: Record<string, string> = {
  active: 'var(--accent)',
  gated: 'transparent',
  broken: 'var(--clay)',
  dormant: 'transparent',
};
const STRIP_SHADOW: Record<string, string> = {
  gated: 'inset 0 0 0 1.5px var(--line-strong)',
  dormant: 'inset 0 0 0 1.5px var(--line)',
};

export function Login() {
  const { login, error } = useSession();
  const [email, setEmail] = useState('admin@nexo.ae');
  const [password, setPassword] = useState('nexo1234');
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
    } catch {
      /* el error se muestra desde la sesión */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <aside className="auth__aside">
        <div className="auth__brand">
          <span className="brandmark">N</span>
          <span className="rail__wordmark">Nexo</span>
        </div>

        <div className="auth__pitch">
          <h1>El software se adapta a lo que tu empresa puede agor.</h1>
          <p>
            Aportas tu licencia comercial; la plataforma revela solo las operaciones que amparan
            your activity and your plan. No menus you do not need, no features that are not yours.
          </p>
        </div>

        <div className="auth__demo">
          <div className="auth__demo-strip">
            {DEMO_STRIP.map((t, i) => (
              <span key={i} style={{ background: STRIP_BG[t], boxShadow: STRIP_SHADOW[t] }} />
            ))}
          </div>
          <span className="auth__demo-legend">SUPERFICIE OPERATIVA · CONCEDIDO / CERRADO / NO APLICA</span>
        </div>
      </aside>

      <main className="auth__main">
        <div className="auth__card">
          <h2>Sign In</h2>
          <p>Access your workspace.</p>

          <form onSubmit={submit}>
            {error && <div className="auth__error">{error}</div>}

            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            </div>

            <div className="field">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            </div>

            <button type="submit" className="btn btn--primary auth__submit" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <div className="auth__demo-users">
            <span className="eyebrow">Demo accounts</span>
            {DEMO.map((u) => (
              <button
                key={u.email}
                className="demo-user"
                onClick={() => {
                  setEmail(u.email);
                  setPassword('nexo1234');
                }}
              >
                <span className="col" style={{ gap: 0 }}>
                  <span className="demo-user__role">{u.role}</span>
                  <span className="faint" style={{ fontSize: 11.5 }}>{u.note}</span>
                </span>
                <span className="demo-user__mail">{u.email}</span>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
